// import React, { useEffect, useState } from "react";
// import { Button } from "react-bootstrap";
// import { BsCheckCircle } from "react-icons/bs";
// import { useSelector } from "react-redux";

// const EditBuyerAgentAccordion = ({
//   userRole,
//   setBuyerAgent,
//   // setAccordionState,
//   // accordionState,
// setCollapseAccordian,
// collapseAccordian,
// }) => {
//   // Get user data from Redux
//   const user = useSelector((state) => state?.user);
//   console.log("ooooo", userRole);
//   const [formState, setFormState] = useState({
//     userType: userRole === "Buyer" ? "Buyer" : "Agent", // Set initial value based on userRole
//     radioSelection: "",
//     error: "",
//   });

//   const QUESTIONS = {
//     BUYER: "Are you represented by an Agent?",
//     AGENT: "Are you buying this property for yourself?",
//   };

//   useEffect(() => {
//     if (userRole) {
//       const newUserType = userRole === "Buyer" ? "Buyer" : "Agent";
//       const radioValue = user?.user?.agentOnly === "N" ? "No" : "Yes";
//       console.log("Setting radio selection to:", radioValue);

//       setFormState((prev) => ({
//         ...prev,
//         userType: newUserType,
//         radioSelection: radioValue,
//       }));

//       // Also update the buyerAgent state
//       const isBuyerAgent =
//         (newUserType === "Buyer" && radioValue === "Yes") ||
//         (newUserType === "Agent" && radioValue === "No");
//       setBuyerAgent(isBuyerAgent);
//     }
//   }, [userRole, user]);

//   // useEffect(() => {
//   //   if (userRole) {
//   //     console.log("userRole:", userRole); // Debug
//   //     const newUserType = userRole === "BUYR" ? "Buyer" : "Agent";
//   //     console.log("setting userType to:", newUserType); // Debug
//   //     setFormState((prev) => ({
//   //       ...prev,
//   //       userType: newUserType,
//   //     }));
//   //   }
//   // }, [userRole]);
//   const updateAccordionState = (newState) => {
//     setAccordionState({
//       ...accordionState,
//       accordion1: { ...accordionState.accordion1, ...newState },
//       accordion2: { close: false, disable: false },
//     });
//   };
// const handleNextAccordian2 = () => {
//   setCollapseAccordian(2);
// };
//   const validateSelection = () => {
//     if (!formState.radioSelection) {
//       setFormState((prev) => ({ ...prev, error: "Please Select one option" }));
//       return false;
//     }
//     return true;
//   };

//   const determineIsBuyerAgent = (value) => {
//     return (
//       (formState.userType === "Buyer" && value === "Yes") ||
//       (formState.userType === "Agent" && value === "No")
//     );
//   };
//   const handleUserTypeChange = (e) => {
//     const { value } = e.target;
//     setFormState((prev) => ({
//       ...prev,
//       userType: value,
//       radioSelection: "",
//       error: "",
//     }));
//   };

//   const handleYesNoChange = (e) => {
//     const { value } = e.target;
//     setFormState((prev) => ({
//       ...prev,
//       radioSelection: value,
//       error: "",
//     }));
//     const isBuyerAgent = determineIsBuyerAgent(value);
//     setBuyerAgent(isBuyerAgent);
//   };

//   // const handleContinue = () => {
//   //   if (validateSelection()) {
//   //     updateAccordionState({ close: true });
//   //   }
//   // };
//   // const handleContinue = () => {
//   //   if (validateSelection()) {
//   //     setAccordionState((prevState) => ({
//   //       ...prevState,
//   //       accordion1: { ...prevState.accordion1, close: true, visited: true },
//   //       accordion2: {
//   //         ...prevState.accordion2,
//   //         close: false,
//   //         disable: false,
//   //         visited: false,
//   //       },
//   //     }));
//   //   }
//   // };
//   // const handleContinue = () => {
//   //   if (validateSelection()) {
//   //     // Create new accordion state with first accordion closed and second accordion open
//   //     const newAccordionState = {
//   //       ...accordionState,
//   //       accordion1: {
//   //         ...accordionState.accordion1,
//   //         close: true,
//   //         visited: true,
//   //       },
//   //       accordion2: {
//   //         ...accordionState.accordion2,
//   //         close: false,
//   //         disable: false,
//   //         visited: true,
//   //       },
//   //     };

//   //     // Update parent state using updateAccordionState
//   //     setAccordionState(newAccordionState);
//   //   }
//   // };

//   // const renderQuestion = () => (
//   //   <p>{userRole === "Buyer" ? QUESTIONS.BUYER : QUESTIONS.AGENT}</p>
//   // );
//   const renderUserTypeQuestion = () => (
//     <>
//       <p>What describes you best?</p>
//       <div className="mb-4">
//         {["Buyer", "Agent"].map((value) => (
//           <div key={value} className="form-check form-check-inline">
//             <input
//               className="form-check-input"
//               type="radio"
//               name="userType"
//               id={value.toLowerCase()}
//               value={value}
//               onChange={handleUserTypeChange}
//               checked={formState.userType === value} // This should now correctly match
//             />
//             <label className="form-check-label" htmlFor={value.toLowerCase()}>
//               {value}
//             </label>
//           </div>
//         ))}
//       </div>
//     </>
//   );

//   const renderSecondQuestion = () =>
//     formState.userType && (
//       <>
//         <p>
//           {formState.userType === "Buyer" ? QUESTIONS.BUYER : QUESTIONS.AGENT}
//         </p>
//         <div className="">
//           {["Yes", "No"].map((value) => (
//             <div key={value} className="form-check form-check-inline">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="buyingForSelf"
//                 id={value === "Yes" ? "buyforself" : "buyforother"}
//                 value={value}
//                 onChange={handleYesNoChange}
//                 checked={formState.radioSelection === value}
//               />
//               <label
//                 className="form-check-label"
//                 htmlFor={value === "Yes" ? "buyforself" : "buyforother"}
//               >
//                 {value}
//               </label>
//             </div>
//           ))}
//         </div>
//       </>
//     );
//   // const renderRadioButtons = () => (
//   //   <div className="values">
//   //     {["Yes", "No"].map((value) => (
//   //       <div key={value} className="form-check form-check-inline">
//   //         <input
//   //           className="form-check-input"
//   //           type="radio"
//   //           name="buyingForSelf"
//   //           id={value === "Yes" ? "buyforself" : "buyforother"}
//   //           value={value}
//   //           onChange={handleChange}
//   //           checked={formState.radioSelection === value}
//   //         />
//   //         <label
//   //           className="form-check-label"
//   //           htmlFor={value === "Yes" ? "buyforself" : "buyforother"}
//   //         >
//   //           {value}
//   //         </label>
//   //       </div>
//   //     ))}
//   //   </div>
//   // );

//   const renderError = () =>
//     formState.error && <p className="error-message">{formState.error}</p>;

//   return (
//     // <div className="border rounded accordion-item mb-2">
//     //   <h2 className="p-1 accordion-header" id="flush-headingOne">
//     //     <button
//     //       className={`accordion-button ${
//     //         accordionState?.accordion1?.close ? "collapsed" : ""
//     //       }`}
//     //       type="button"
//     //       data-bs-toggle="collapse"
//     //       data-bs-target="#flush-collapseOne"
//     //       aria-expanded="true"
//     //       aria-controls="flush-collapseOne"
//     //     >
//     //       Buyer / Agent Information
//     //     </button>
//     //   </h2>
//     //   <div
//     //     id="flush-collapseOne"
//     //     className={`accordion-collapse collapse ${
//     //       accordionState?.accordion1?.close ? "" : "show"
//     //     }`}
//     //     aria-labelledby="flush-headingOne"
//     //     data-bs-parent="#accordionFlushExample"
//     //   >
//     //     <div className="accordion-body">
//     //       <div className="d-flex flex-column align-items-start buyer-or-agent">
//     //         <div> {renderUserTypeQuestion()} </div>

//     //         <div> {renderSecondQuestion()}</div>
//     //       </div>
//     //       {renderError()}
//     //       <button
//     //         className="btn btn-primary continue-button"
//     //         onClick={handleContinue}
//     //       >
//     //         Continue
//     //       </button>
//     //     </div>
//     //   </div>
//     // </div>
//     <div
//       className="accordion-item"
//       // style={{ display: showAccordian1 ? "none" : "block" }}
//     >
//       <h2 className="accordion-header">
//         <button
//           className={`accordion-button ${
//             collapseAccordian === 1 ? "" : "collapsed"
//           }`}
//           type="button"
//           onClick={() => setCollapseAccordian(1)}
//           aria-expanded={collapseAccordian === 1}
//         >
//           <div className="d-flex align-items-center">
//             <BsCheckCircle className="text-dark me-2" size={20} />
//             <span>Buyer/ Agent Information</span>
//           </div>
//         </button>
//       </h2>
//       <div
//         className={`accordion-collapse collapse ${
//           collapseAccordian === 1 ? "show" : ""
//         }`}
//         data-bs-parent="#accordionFlushExample"
//       >
//         {/* Original accordion body with all logic stays exactly the same */}
//         <div className="accordion-body">
//           <div className="d-flex flex-column align-items-start buyer-or-agent">
//             <div> {renderUserTypeQuestion()} </div>
//             <div> {renderSecondQuestion()}</div>
//           </div>
//           {renderError()}
//           {/* <button
//             className="btn btn-primary continue-button"
//             onClick={handleContinue}
//           >
//             Continue
//           </button> */}
//           <Button
//             variant="primary"
//             // style={{ width: "20%" }}
//             size="md"
//             onClick={handleNextAccordian2}
//           >
//             Continue
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditBuyerAgentAccordion;
import PurchaseProfileBuyerAgentDesc from "@/components/bid/PurchaseProfileBuyerAgentDesc";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { BsCheckCircle, BsCheckCircleFill } from "react-icons/bs";
import "./editcif.css";
import { errors } from "jose";
const EditBuyerAgentAccordian = ({
  setCollapseAccordian,
  collapseAccordian,
  setSelectedDescription,
  setBuyingForSelf,
  selectedDescription,
  buyingForSelf,
  user,
  cifData,
  submittedAccordions,
  setSubmittedAccordions,
}) => {
  console.log("user is", user);

  //   useEffect(() => {
  //     if (cifData?.data) {
  //       // Set initial description based on loggedInUserRole
  //       if (cifData.data.loggedInUserRole) {
  //         setSelectedDescription(cifData.data.loggedInUserRole);
  //       }

  //       // If user is a Buyer, set buyingForSelf based on representedByAgent
  // // '  "agentFlag": "Y",
  // //         "representedByAgent": "N",'
  //       if(cifData.data.agentFlag === 'Y'){
  //         setSelectedDescription('Agent');
  //          setBuyingForSelf(
  //           cifData.data.representedByAgent === "N" ? "Yes" : "No"
  //         );
  //       }else{
  //          setSelectedDescription('Buyer');
  //           setBuyingForSelf(
  //           cifData.data.representedByAgent === "Y" ? "Yes" : "No"
  //         );
  //       }

  //     }
  //   }, [cifData]);

  const handleBuyingForSelfChange = (e) => {
    console.log("buying for self", e.target.value);
    setBuyingForSelf(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setSelectedDescription(e.target.value);
  };
  const handleNextAccordian2 = () => {
    console.log("errors -> ", errors);
    setSubmittedAccordions((prev) => [...prev, 1]); // Mark first accordion as submitted
    setCollapseAccordian(2);
  };
  return (
    <>
      <div
        className="accordion-item buyer-agent-accordion"
        // style={{ display: showAccordian1 ? "none" : "block" }}
      >
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${
              collapseAccordian === 1 ? "" : "collapsed"
            }`}
            type="button"
            onClick={(e) => e.preventDefault()}
            aria-expanded={collapseAccordian === 1}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center">
                {submittedAccordions?.includes(1) && collapseAccordian !== 1 ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
                <span className="bid_font_cif">Buyer/ Agent Information</span>
              </div>

              {collapseAccordian !== 1 && (
                <Button
                  variant=""
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCollapseAccordian(1);
                  }}
                  className="editCifLink"
                >
                  Edit
                </Button>
              )}
            </div>
          </button>
        </h2>
        {/* Summary section */}
        {collapseAccordian !== 1 &&
          submittedAccordions?.includes(1) &&
          selectedDescription && (
            <div className="buyer-agent-summary p-2 border-bottom">
              <div className="ms-4">
                <p className="mb-4">
                  <strong className="cifTxt">What describes you best?:</strong>{" "}
                  {selectedDescription}
                </p>
                <p className="mb-3">
                  <strong className="cifTxt">
                    {selectedDescription === "Buyer"
                      ? "Are you Represented by an Agent?"
                      : "Are you buying this property for yourself?"}
                    :
                  </strong>{" "}
                  {buyingForSelf}
                </p>
              </div>
            </div>
          )}
        <div
          className={`accordion-collapse collapse ${
            collapseAccordian === 1 ? "show" : ""
          }`}
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            <Container className="mt-4">
              <Form>
                <Form.Group as={Row} className="mb-3">
                  <Col sm="12">
                    <Form.Label className="cifTxt">
                      What describes you best?
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Col>
                  <Col sm="12">
                    <div className="d-flex">
                      <Form.Check
                        type="radio"
                        label="Buyer"
                        name="bestDescription"
                        value="Buyer"
                        required
                        className="me-3"
                        onChange={handleDescriptionChange}
                        checked={selectedDescription === "Buyer"}
                      />
                      <Form.Check
                        type="radio"
                        label="Agent"
                        name="bestDescription"
                        value="Agent"
                        required
                        onChange={handleDescriptionChange}
                        checked={selectedDescription === "Agent"}
                      />
                    </div>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Col sm="12">
                    <Form.Label className="cifTxt">
                      {selectedDescription === "Buyer"
                        ? "Are you represented by an Agent?"
                        : "Are you buying this property for yourself? "}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Col>
                  <Col sm="12">
                    <div className="d-flex">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        name="buyingForSelf"
                        value="Yes"
                        required
                        className="me-3"
                        onChange={handleBuyingForSelfChange}
                        checked={buyingForSelf === "Yes"}
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        name="buyingForSelf"
                        value="No"
                        required
                        onChange={handleBuyingForSelfChange}
                        checked={buyingForSelf === "No"}
                      />
                    </div>
                  </Col>
                </Form.Group>
                {selectedDescription === "Buyer" && buyingForSelf === "No" && (
                  <PurchaseProfileBuyerAgentDesc />
                )}
                {selectedDescription === "Agent" && buyingForSelf === "Yes" && (
                  <PurchaseProfileBuyerAgentDesc />
                )}

                <Button
                  variant="primary"
                  className="continueCTA"
                  // style={{ width: "20%" }}
                  size="md"
                  onClick={handleNextAccordian2}
                >
                  Continue
                </Button>
              </Form>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBuyerAgentAccordian;
